import React from "react";
import { useRanking } from "@/context/RankingContext";
import { ScenarioBuilder } from "@/components/ScenarioBuilder";

/**
 * The same scenario wizard, just on its own page /scenario
 */
export function ScenarioPage() {
  const { depaulRank } = useRanking();

  return (
    <div className="w-full">
      <ScenarioBuilder currentRank={depaulRank} />
    </div>
  );
}